module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('headerTop', {
    attrs: {
      "value": "2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shenbaoA flex justify-between align-start"
  }, [_c('div', {
    staticStyle: {
      "width": "1144px",
      "min-height": "600px"
    }
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "width": "1144px",
      "padding": "120px 100px 20px",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "sd_title"
  }, [_c('p', {
    staticClass: "biaoti1"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('p', {
    staticClass: "bt_mes"
  }, [(_vm.detail.create_time) ? _c('span', [_vm._v("发布时间：" + _vm._s(_vm.detail.create_time))]) : _vm._e(), _vm._v(" "), (_vm.detail.created_at) ? _c('span', [_vm._v("发布时间：" + _vm._s(_vm.detail.created_at))]) : _vm._e(), _vm._v(" "), (_vm.detail.form) ? _c('span', [_vm._v("来源：" + _vm._s(_vm.detail.form))]) : _vm._e()])]), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "sd_content"
  }, [(_vm.detail.territory) ? _c('div', {
    staticClass: "cardView"
  }, [_c('div', {
    staticClass: "tagtext"
  }, [_vm._v("支持领域")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.territory)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.detail.according) ? _c('div', {
    staticClass: "cardView"
  }, [_c('div', {
    staticClass: "tagtext"
  }, [_vm._v("依据文件")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.according)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.detail.content) ? _c('div', {
    staticClass: "cardView"
  }, [_c('div', {
    staticClass: "tagtext"
  }, [_vm._v("最新动态")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.detail.declare_condition) ? _c('div', {
    staticClass: "cardView"
  }, [_c('div', {
    staticClass: "tagtext"
  }, [_vm._v("申报条件")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.declare_condition)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.detail.effort) ? _c('div', {
    staticClass: "cardView"
  }, [_c('div', {
    staticClass: "tagtext"
  }, [_vm._v("支持力度")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.level,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "align": "center",
      "width": "100px",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "align": "center",
      "width": "100px",
      "label": "支持等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factor",
      "align": "center",
      "width": "180px",
      "label": "资助条件"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money",
      "align": "center",
      "label": "资助金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参考文件",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cpoint",
          staticStyle: {
            "color": "#0081ff"
          },
          attrs: {
            "data-url": scope.row.href
          },
          on: {
            "click": function($event) {
              return _vm.toout(scope.row.href)
            }
          }
        }, [_vm._v(_vm._s(scope.row.file))])]
      }
    }], null, false, 1920358502)
  })], 1)], 1)]) : _vm._e()]) : _c('div', {
    staticClass: "sd_content padding-top"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "40px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c99dfb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/policy/detail.vue
// module id = 1105
// module chunks = 1